import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MenuNav, MenuCategory } from './MenuNav';
import { Kebabs } from './Kebabs';
import { BakedPotatoes } from './BakedPotatoes';
import { Extras } from './Extras';
import { Drinks } from './Drinks';
const CATEGORY_CONTENT: Record<MenuCategory, React.ReactNode> = {
  kebabs: <Kebabs data-id="element-103" data-mp="1r05mgu8hpab3" />,
  papas: <BakedPotatoes data-id="element-104" data-mp="1qxjgv055t4vi" />,
  extras: <Extras data-id="element-105" data-mp="1399yy9b2h19n" />,
  bebidas: <Drinks data-id="element-106" data-mp="13auspwpk4g6g" />
};
export function MenuSection() {
  const [active, setActive] = useState<MenuCategory>('kebabs');
  return <>
      <MenuNav active={active} onChange={setActive} data-id="element-107" data-mp="ycjhpinizzmn" />

      {/* Single content zone — only the active category renders here.
            The page does not scroll; content swaps in place with a soft fade. */}
      <div className="w-full bg-bp-bg" data-id="element-108" data-mp="179ag41pjvqke">
        <AnimatePresence mode="wait" data-id="element-109" data-mp="jl0w95bwdcvw">
          <motion.div key={active} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.2,
          ease: 'easeInOut'
        }} data-id="element-110" data-mp="jjzkeyn24md4">
            {CATEGORY_CONTENT[active]}
          </motion.div>
        </AnimatePresence>
      </div>
    </>;
}